import FlashLib from "flashlib_onlyplay";
import animationCreator from 'Engine/animations/animationCreator';
import animationTypes from '../animations/animationTypes';
import EntryPoint from '../libs/game-engine/src/EntryPoint';

export default class BackgroundContainerFront extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.init();
        // this.createTweens();
        if (!EntryPoint.mobile) {
            this.initAnimation();
        }
        this.addListeners();
    }

    init() {
        // this.freeSpinsBackground = this.getChildByName('freeSpinsBackground');
        // this.freeSpinsBackground.visible = false;
        this.background = this.getChildByName('background');
    }

    addListeners() {
        window.OPWrapperService.eventManager.add(
          window.OPWrapperService.eventManager.types.EET_SCALE_MANAGER_RESIZE,
          this.onResize,
          this
        );
    }

    onResize (data) {
        if (data.isLandscape) {
            this.goToFrame(2)
            this.isPortrait = false;
            // this.animation.state.setAnimation(0, 'bg_coins_joker_x_mas', true);
        } else if (data.isMobile && data.isPortrait) {
            this.goToFrame(1)
            this.isPortrait = true;
            // this.animation.state.setAnimation(0, 'bg_coins_joker_x_mas_mob', true);
        }
    }

    initAnimation() {
        this.animationSnow = animationCreator.createAnimation(animationTypes.BACKGROUND);
        this.animationSnow.state.setAnimation(0, 'front_snow', true);
        this.getChildByName('animationPlace').addChild(this.animationSnow);
    }
}
